export const version = 'kunde-v1.20.0-SNAPSHOT-99f3dfe3cb875223b6392d972a09e664389bbe3f';